import { Injectable } from "@angular/core";
import { validationRegex } from "@obg/ngx.global";
import { toArray } from "lodash-es";

import { PasswordStrength } from "./password-strength.model";

@Injectable({
	providedIn: "root",
})
export class PasswordStrengthService {
	private passwordStrengthRegExArray = toArray(validationRegex.passwordStrength);

	measurePasswordStrength(password: string): PasswordStrength {
		if (password) {
			return (this.passwordStrengthRegExArray.filter((regExp) => !!password.match(regExp)).length +
				1) as PasswordStrength;
		}
		return PasswordStrength.Empty;
	}
}
